<template>
   <div>
    <div class="pop" v-show="show5" @touchmove.prevent></div>
    <div class="edit5" v-show="show5">
      <div class="text-center ddd" style="border-bottom: 1px solid #f7f8f9;">
        <h4 class="message">{{message}}</h4>
        <!-- <hr> -->
      </div>
      <div style="text-align: center;" @click="editShow">
        <button>确定</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      show: false,
    }
  },
  components: {
  },
  props: {
    show5: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    editShow () {
      this.$emit("editshow")
    }
  }


}
</script>
<style>
.ddd {
  min-height: 104px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.message {
  margin: 0;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-height: 60vh;
  /* line-height: 60px; */
  padding: 26px 24px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  text-align: center;
  word-wrap: break-word;
  display: block;
}
.pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 99;
}
.edit5 {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 152px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 16px;
  padding: 0;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}

.edit5 button {
  height: 48px;
  line-height: 48px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: none !important;
  color: #01b2c2;
  /* margin-left: 10px; */
  cursor: pointer;
  margin: 0;
  padding-top: 0px;
  /* margin-top: 25px; */
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/popup.vue